import { render, staticRenderFns } from "./AllianceIntroPage.vue?vue&type=template&id=115969a0&scoped=true"
import script from "./AllianceIntroPage.vue?vue&type=script&lang=js"
export * from "./AllianceIntroPage.vue?vue&type=script&lang=js"
import style0 from "./AllianceIntroPage.vue?vue&type=style&index=0&id=115969a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115969a0",
  null
  
)

export default component.exports